import React from "react";
import { FormattedText } from "../components/common/FormattedText";

export default function useStopsFilter(searchValue, stops) {
  const stopsToReturn = {
    scheduled: [],
    unscheduled: []
  };
  const infoToReturn = {
    scheduled: [],
    unscheduled: []
  };

  const mapFn = stop => {
    const contactName = stop?.information?.recipient_name;
    const title = stop?.information?.street
      ? (stop?.information && stop?.information?.street) || ""
      : `${stop?.address.lat}, ${stop?.address.lng}`;
    const subtitle =
      (stop?.information?.zipcode ? stop?.information?.zipcode + ", " : "") +
      ((stop?.information && stop?.information?.city) || "") +
      (stop?.information && stop?.information?.country
        ? (stop?.information?.city && stop?.information?.country ? ", " : "") +
          stop?.information?.country
        : "");

    const tags = stop?.tags?.map(tag => tag?.name).join(",") || "";
    if (contactName) return [contactName, title + ", " + subtitle, tags];
    return [title, subtitle, tags];
  };

  const infoToReturnInitial = {
    unscheduled: stops?.unscheduled.map(mapFn),
    scheduled: stops?.scheduled.map(mapFn)
  };

  searchValue = searchValue.trim().toLowerCase();
  if (!searchValue) {
    infoToReturnInitial.unscheduled = infoToReturnInitial.unscheduled.map(
      strings => [
        <FormattedText query={searchValue} text={strings[0]} />,
        <FormattedText query={searchValue} text={strings[1]} />,
        <FormattedText query={searchValue} text={strings[2]} />
      ]
    );

    infoToReturnInitial.scheduled = infoToReturnInitial.scheduled.map(
      strings => [
        <FormattedText query={searchValue} text={strings[0]} />,
        <FormattedText query={searchValue} text={strings[1]} />,
        <FormattedText query={searchValue} text={strings[2]} />
      ]
    );

    return [stops, infoToReturnInitial];
  }

  const forEachFn = (strings, i, field) => {
    strings.some(str => {
      if (str && str.toLowerCase().includes(searchValue)) {
        infoToReturn[field].push([
          <FormattedText query={searchValue} text={strings[0]} />,
          <FormattedText query={searchValue} text={strings[1]} />,
          <FormattedText query={searchValue} text={strings[2]} />
        ]);
        stopsToReturn[field].push(stops[field][i]);
        return true;
      }
      return false;
    });
  };

  infoToReturnInitial.unscheduled.forEach((strings, i) =>
    forEachFn(strings, i, "unscheduled")
  );
  infoToReturnInitial.scheduled.forEach((strings, i) =>
    forEachFn(strings, i, "scheduled")
  );

  return [stopsToReturn, infoToReturn];
}
